import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { IssueCreateSidePanelProps } from '../src/__types__/IssueCreateSidePanel.ts';
export {
	ISSUE_CREATE_SIDE_PANEL_ID,
	ISSUE_CREATE_SIDE_PANEL_WIDTH,
} from '../src/ui/single-work-create/IssueCreateSidePanel.tsx';
export const IssueCreateSidePanel: LoadableType<Omit<IssueCreateSidePanelProps, 'flags'>> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-IssueCreateSidePanel" */ '../src/ui/single-work-create/IssueCreateSidePanel.tsx'
				)
			).IssueCreateSidePanel,
	});
